<template>
  <section>
    <div class="modal-card" style="height: 1000px; width: 100%">
      <header class="modal-card-head">
        <p>Vista Previa</p>
      </header>
      <section class="modal-card-body">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <div class="columns">
          <div class="column is-4">
            <b-field label="Número de Documento" :label-position="'on-border'">
              <b-input v-model="document.number" disabled></b-input>
            </b-field>
            <b-field label="Fecha del documento" :label-position="'on-border'">
              <b-input v-model="document.date_document" disabled></b-input>
            </b-field>
            <b-field label="Descripción" :label-position="'on-border'">
              <b-input
                v-model="document.description"
                type="textarea"
                disabled
              ></b-input>
            </b-field>
            <b-field label="Tipo de documento" :label-position="'on-border'">
              <b-input v-model="document.document_type.name" disabled></b-input>
            </b-field>
            <b-field label="Bodega" :label-position="'on-border'">
              <b-input v-model="document.cellar.name" disabled></b-input>
            </b-field>
            <b-field label="Tipo de remitente" :label-position="'on-border'">
              <b-input v-model="document.type_remitent.name" disabled></b-input>
            </b-field>
            <b-field
              v-if="document.remitent"
              label="Remitente"
              :label-position="'on-border'"
            >
              <b-input v-model="document.remitent.name" disabled></b-input>
            </b-field>
          </div>
          <div class="column" style="width: 100%; height: 500px">
            <iframe
              :src="document.file"
              style="width: 100%; height: 100%"
              allowfullscreen
              webkitallowfullscreen
            ></iframe>
            <br />
            <a :href="document.file" target="_blank">
              <b-button type="is-primary" icon-left="download"
                >Descargar</b-button
              >
            </a>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          Cerrar
        </button>
      </footer>
    </div>
  </section>
</template> 
<script>
// import { getDocument, updateDocument } from "../../../services/document";
import { DocumentService } from "../../../services/models/document";

export default {
  props: ["id", "chargeDocumentList"],
  data() {
    return {
      isLoading: false,
      document: {
        cellar: {
          name: null,
        },
        document_type: {
          name: null,
        },
        type_remitent: {
          name: null,
        },
        remitent: {
          name: null,
        },
      },
      isFocused: false,
    };
  },
  mounted() {
    this.chargeData();
  },
  methods: {
    async chargeData() {
      this.isLoading = true;
      const { data: document } = await DocumentService.getById(this.id);
      this.document = document;
      this.isLoading = false;
    },
  },
};
</script>